import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import ViewMembersPanel from "../../../../../components/view-members/view-members";
import "./group-row.styles.scss";
import {
  addSelectedGroup,
  deleteSelectedGroup,
} from "../../../../../redux/groups/group-actions";
import { selectSelectedGroups } from "../../../../../redux/groups/group-selector";
import { useSelector, useDispatch } from "react-redux";
import AdminActionsPopupNew from "../../admin-actions-popup/AdminActionsPopupNew";
import PropTypes from "prop-types";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const GroupRowNew = ({ data, privileges,onArchiveSuccess }) => {
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedRows = useSelector(selectSelectedGroups);

  const onEdit = () => {
    if (!privileges.Group.Edit === false) {
      history.push(`/admin/groups/edit/${data.Id}`);
    }
  };

  const onArchive = () => {
    if (!privileges.Group.Delete === false) {
      setShowAdminActionsPopup(true);
    }
  };

  const onSelect = (e) => {
    if (e.target.checked) {
      dispatch(addSelectedGroup(data.Id));
    } else {
      dispatch(deleteSelectedGroup(data.Id));
    }
  };

  return (
    <tr className="group-row-1">
      <td className="th-checkbox-col">
        <Form.Check
          type={"checkbox"}
          disabled={!privileges.Group.Delete}
          onClick={(e) => {
            onSelect(e);
          }}
          checked={selectedRows.includes(data.Id)}
        />
      </td>
      <td className="data-text group-name">{data.Name}</td>
      <td className="data-text group-description">
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            delay={{ show: 150, hide: 150 }}
            overlay={
              <Popover id="description-popover" className="custom-popover">
                <Popover.Content>
                  {data.Description ? data.Description : ""}
                </Popover.Content>
              </Popover>
            }
          >
            <div className="text-wrapper">
              <span className="text-content">{data.Description ? data.Description : ""}</span>
            </div>
        </OverlayTrigger>
      </td>
      <td className="data-text group-creator">{data.CreatedBy.Name}</td>

      <td className="assigned-by-row group-members">
        <ViewMembersPanel
          taskType={1}
          UserID={data.CreatedById}
          members={data.ViewMembers}
          isGroup={true}
        ></ViewMembersPanel>
      </td>

      <td className="data-number group-size">{data.Size}</td>
      <td className="admin-row-status group-status">
        {data.Active ? (
          <div className="status active">Active</div>
        ) : (
          <div className="status inactive">Inactive</div>
        )}
      </td>
      <td className="admin-row-action-buttons">
        <Button
          disabled={!privileges.Group.Delete}
          className={`btn-icon1 ${
            !privileges.Group.Delete === false
              ? "archive-icon1"
              : "archive-icon1-disabled"
          }`}
          onClick={() => onArchive()}
          title="Archive"
        />

        <Button
          disabled={!privileges.Group.Edit}
          className={`btn-icon1 ${
            !privileges.Group.Edit === false
              ? "edit-icon1"
              : "edit-icon1-disabled"
          }`}
          onClick={() => onEdit()}
          title="Edit"
        />
      </td>

      {showAdminActionsPopup && (
        <AdminActionsPopupNew
          type={"group"}
          name={data.Name}
          selectedIDs={[data.Id]}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
          onArchiveSuccess={onArchiveSuccess}
        />
      )}
    </tr>
  );
};

GroupRowNew.propTypes = {
  data: PropTypes.object.isRequired,
  privileges: PropTypes.object.isRequired,
  onArchiveSuccess: PropTypes.func,
};

export default GroupRowNew;
